// interfaces
import {
    AddMoneyResponseData,
    AddMoneyWalletFormParams,
    MobikwikCheckSumData,
} from "@payment-client/interfaces/WalletPublic";

// constants
import { WALLET_CONFIG } from "@payment-client/constants/WalletUrls";

const getAddMoneyFormData = (
    data: MobikwikCheckSumData,
    params: AddMoneyWalletFormParams,
): { [key: string]: string } => {
    return {
        amount: params.amount as string,
        cell: params.cell as string,
        merchantname: WALLET_CONFIG.MOBIKWIK_MERCHANT_NAME || "",
        mid: WALLET_CONFIG.MOBIKWIK_MID,
        orderid: data.orderid,
        redirecturl: data.redirectUrl,
        token: data.token,
        checksum: data.checksum,
    };
};

export const getMobikwikFormData = async (
    data: MobikwikCheckSumData,
    params: AddMoneyWalletFormParams,
): Promise<AddMoneyResponseData> => {
    const formData = getAddMoneyFormData(data, params);
    return {
        url: WALLET_CONFIG.MOBIKWIK_GATEWAY_URL,
        params: formData,
    };
};
